(function () {
  'use strict';

  angular
      .module('tf.retailer.Analytics')
      .controller('AnalyticsViewCtrl', AnalyticsViewCtrl)
      .directive('tfcAnalyticsView', tfcAnalyticsView);

  // @ngInject
  function AnalyticsViewCtrl($scope, AnalyticsConfig, AnalyticsApi) {
    var vm = this,
        experimentType = vm.experiment && vm.experiment.experimentType,
        experimentKey = vm.experiment && vm.experiment.key;

    vm.tabs = AnalyticsConfig.getTabs(experimentType);
    vm.tab = vm.tabs[0];
    vm.summaryMetrics = AnalyticsConfig.summaryMetrics(experimentType);
    vm.chartMetrics = AnalyticsConfig.chartMetrics(experimentType);
    // map of Metric -> MetricResults
    // will be null until the first metric loads
    vm.metrics = null;

    var allMetrics = Object.keys(angular.merge(
        concatMetrics(vm.summaryMetrics),
        concatMetrics(vm.chartMetrics)
    ));
    loadMetrics(allMetrics);

    function loadMetrics(metrics, params) {
      return AnalyticsApi.getAllMetricData(vm.tla, angular.merge({}, params, {
        metric : metrics,
        experiment : experimentKey
      })).then(function (resultSet) {
        vm.metrics = angular.extend(vm.metrics || {}, resultSet);
      });
    }

    vm.metricData = function (metric) {
      return vm.metrics && vm.metrics[metric];
    };

    vm.lastUpdated = function () {
      return _.max(_.map(vm.metrics, 'lastUpdated'));
    };

    vm.refresh = function () {
      $scope.$broadcast('chart.reload');
    };

    vm.loadMetric = function (metric, params) {
      return loadMetrics(metric, params);
    };

    // Map[String, Set[Metric]] => Set[Metric]
    function concatMetrics(metricMap) {
      var all = {};
      angular.forEach(metricMap, function (metrics) {
        angular.forEach(metrics, function (m) {
          all[m] = m;
        });
      });
      return all;
    }
  }

  // @ngInject
  function tfcAnalyticsView() {
    return {
      controller : 'AnalyticsViewCtrl as vm',
      bindToController : true,
      templateUrl: 'Analytics/AnalyticsView.tmpl.html',
      scope : {
        tla : '@',
        experiment : '=',
        intervals : '='
      }
    };
  }

})();
